/**
 * Build src / srcSet / sizes for static-export responsive images.
 * Variants are generated by scripts/generate-responsive-images.cjs as:
 *   /path/name-400w.webp  /path/name-640w.webp  /path/name.webp (master, max width)
 */

const DEFAULT_WIDTHS = [400, 640, 960];

export function responsiveImage(src, { widths = DEFAULT_WIDTHS, sizes } = {}) {
  if (!src) return { src, srcSet: undefined, sizes: undefined };

  const q = src.indexOf('?');
  const base = q === -1 ? src : src.slice(0, q);
  const query = q === -1 ? '' : src.slice(q);

  // SVG/AVIF have no -Nw variants from optimize:images — skip srcSet.
  // Match on `base` (path without ?v=…) so cache-bust query strings don't
  // defeat the extension check (e.g. razorpay.svg?v=4).
  if (/\.(svg|avif)$/i.test(base)) {
    return { src: `${base}${query}`, srcSet: undefined, sizes: undefined };
  }

  const ext = base.match(/\.[a-z0-9]+$/i)?.[0] || '.webp';
  const stem = base.slice(0, -ext.length);
  const masterW = widths[widths.length - 1];

  const parts = widths.map((w) => `${stem}-${w}w${ext}${query} ${w}w`);
  parts.push(`${base}${query} ${masterW}w`);

  return {
    src: `${base}${query}`,
    srcSet: parts.join(', '),
    sizes,
  };
}

/** Marquee logos — shown ~40px tall, max ~195px wide. */
export const LOGO_WIDTHS = [160, 240, 320];
export const LOGO_SIZES = '195px';

/** Hero carousel — right column ~50% of content area. */
export const HERO_WIDTHS = [400, 640, 960];
/** Mobile ~92vw (~360–400px) → 400w; tablet ≤560px; desktop ~600px. */
export const HERO_SIZES =
  '(max-width: 640px) 92vw, (max-width: 900px) min(92vw, 560px), 600px';

/** Capabilities card media — 3-col grid. */
export const CAPABILITY_WIDTHS = [400, 640];
export const CAPABILITY_SIZES = '(max-width: 620px) 92vw, (max-width: 1000px) 46vw, 380px';

/** Book-demo robot + channels wheel + integrations collage. */
export const BAND_WIDTHS = [400, 640, 960];
export const BAND_SIZES = '(max-width: 900px) min(92vw, 560px), 520px';

/** AI engine card art. */
export const ENGINE_WIDTHS = [400, 640];
export const ENGINE_SIZES = '(max-width: 900px) min(88vw, 420px), 360px';
